import React from 'react';
import CustomModal from '../CustomModal/CustomModal';
import { Table, Spinner } from 'react-bootstrap';
import UtilityService from '../../services/UtillityServices/UtilityService';

function VoucherUsageModal({ show, onHide, isLoading, data, voucher }) {

  // DEBUG 1: Vediamo cosa riceve il componente a ogni render
  
 
  return (
    <CustomModal
        show={show}
        onHide={onHide}
        headerText={`Utilizzi Voucher per: ${voucher?.nome_corso || ''}`}
        size="lg"
        hideSaveBtn={true}
        onUndoChanges={onHide}
        body={isLoading ? (
            <div className="text-center p-5"> 
                <Spinner animation="border" variant="primary" />
                <p className="mt-2">Caricamento utilizzi...</p>
            </div>
        ) : data.length > 0 ? (
            <div className="table-responsive">
                <Table striped bordered hover size="sm">
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Cognome</th>
                            <th>Data Utilizzo</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((user, index) => (
                            <tr key={index}>

                                <td>{user.nome}</td>
                                <td>{user.cognome}</td>
                                <td>{UtilityService.formatDate(user.data_utilizzo)}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        ) : (
            <div className="text-center p-5">
                <p className="text-muted">Nessun utilizzo registrato per questo pacchetto voucher.</p>
            </div>
        )}
    >
        
    </CustomModal>
  );
}

export default VoucherUsageModal;
